import { apiClient } from "./api-client"
import type {
  ReportList,
  ReportListCreateRequest,
  ReportListUpdateRequest,
} from "@/types/report-list"
import { demoReportLists } from "@/data/demo-data"

const BASE_PATH = "/ReportingInterface"
const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true"

export const reportListApi = {
  async getAllReportLists(): Promise<ReportList[]> {
    if (isDemoMode) {
      return demoReportLists
    }
    return apiClient.get(`${BASE_PATH}/GetAllReportLists`)
  },

  async getReportListByKey(reportListKey: string): Promise<ReportList> {
    if (isDemoMode) {
      const list = demoReportLists.find((l) => l.reportListKey === reportListKey)
      if (!list) {
        throw new Error("Report list not found")
      }
      return list
    }
    return apiClient.get(`${BASE_PATH}/GetReportListByKey/${reportListKey}`)
  },

  async createReportList(
    request: ReportListCreateRequest
  ): Promise<{ reportListKey: string }> {
    if (isDemoMode) {
      return { reportListKey: `demo-list-${Date.now()}` }
    }
    return apiClient.post(`${BASE_PATH}/CreateReportList`, request)
  },

  async updateReportList(request: ReportListUpdateRequest): Promise<void> {
    if (isDemoMode) {
      return
    }
    return apiClient.put(`${BASE_PATH}/UpdateReportList`, request)
  },

  async deleteReportList(reportListKey: string): Promise<void> {
    if (isDemoMode) {
      return
    }
    return apiClient.delete(
      `${BASE_PATH}/DeleteReportListByKey/${reportListKey}`
    )
  },
}
